import { IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";
import PhotoSizeSelectActualIcon from "@mui/icons-material/PhotoSizeSelectActual";
import PhotoSizeSelectLargeIcon from "@mui/icons-material/PhotoSizeSelectLarge";

export default function ImageTransparencySelector({
  transparent,
  setTransparent,
}) {

  const handleClick = () => {
    const newValue = !transparent;
    setTransparent(newValue);
  };

  return (
    <Tooltip
      title={transparent ? "transparent bg" : "normal bg"}
      placement="top"
    >
      <IconButton onClick={handleClick} color="secondary">
        {transparent ? (
          <PhotoSizeSelectLargeIcon />
        ) : (
          <PhotoSizeSelectActualIcon />
        )}
      </IconButton>
    </Tooltip>
  );
}
